import { EXISTING_POSTS } from './existing'
import { ACCOUNT_POSTS } from './account'
import { TROUBLESHOOTING_POSTS } from './troubleshooting'
import { UPDATES_POSTS } from './updates'
import { BACKUP_POSTS } from './backup'
import { FEATURES_POSTS } from './features'
import { BLOG_BODY_TAIL } from '@/utils/blogBodyExtras.js'

function withBlogBodyTails(posts) {
	const out = { ...posts }
	Object.keys(out).forEach((key) => {
		const post = out[key]
		const tail = BLOG_BODY_TAIL[post.slug]
		if (tail) {
			out[key] = { ...post, body: `${post.body.trim()}${tail}` }
		}
	})
	return out
}

export const BLOG_POSTS = withBlogBodyTails({
	...EXISTING_POSTS,
	...ACCOUNT_POSTS,
	...TROUBLESHOOTING_POSTS,
	...UPDATES_POSTS,
	...BACKUP_POSTS,
	...FEATURES_POSTS,
})

/** 上一篇 / 下一篇阅读顺序 */
export const BLOG_POST_ORDER = [
	'is-gb-whatsapp-safe',
	'will-gb-whatsapp-get-you-banned',
	'why-is-gb-whatsapp-account-banned',
	'gb-whatsapp-says-use-official-whatsapp',
	'does-gb-whatsapp-anti-ban-work',
	'gb-whatsapp-verification-code-not-received',
	'gb-whatsapp-keeps-crashing',
	'gb-whatsapp-installation-error',
	'gb-whatsapp-messages-not-sending',
	'gb-whatsapp-status-download-not-working',
	'gb-whatsapp-update-failed',
	'gb-whatsapp-expired-version',
	'gb-whatsapp-not-working-after-update',
	'gb-whatsapp-android-compatibility',
	'gb-whatsapp-backup-not-working',
	'restore-gb-whatsapp-chats',
	'switch-from-gb-whatsapp-to-official-whatsapp',
	'transfer-gb-whatsapp-to-new-phone',
	'schedule-messages-gb-whatsapp',
	'lock-individual-chats-gb-whatsapp',
	'hide-blue-ticks-gb-whatsapp',
	'use-gb-whatsapp-dnd-mode',
	'download-gb-whatsapp-status-videos',
]

export const BLOG_POST_LIST = BLOG_POST_ORDER.filter((slug) => BLOG_POSTS[slug]).map((slug) => {
	const post = BLOG_POSTS[slug]
	return {
		...post,
		path: `/${post.slug}/`,
	}
})
